import { useState } from 'react';
import {
  VStack,
  Text,
  InputGroup,
  InputLeftAddon,
  HStack,
  Box,
  TextArea,
} from 'native-base';

// APIs
import { regionFlag } from '@breakroom-nx/apis';

// Assets
import { theme } from '@breakroom-nx/assets';

// Classes & Types
import { InputType } from '@breakroom-nx/helpers';

// Props
type Props = {
  title?: string;
  isRequired: boolean;
  type: InputType;
  autoCapitalize?: 'none' | 'sentences' | 'words' | 'characters' | undefined;
  autoCorrect?: boolean;
  placeholder: string;
  value?: string;
  onChangeText?: any;
  onBlur?: any;
  height?: number | string;
  maxHeight?: number | string;
  placeholderTextColor?: string;
  inactiveTextColor?: string;
  disabled?: boolean;
};

export const TextView = ({
  title = undefined,
  isRequired = true,
  type = InputType.Text,
  autoCapitalize = 'none',
  autoCorrect = false,
  placeholder,
  value = undefined,
  onChangeText = undefined,
  onBlur = undefined,
  height = undefined,
  maxHeight = undefined,
  placeholderTextColor = undefined,
  inactiveTextColor = undefined,
  disabled = false,
}: Props) => {
  const [focused, setFocused] = useState(false);
  const requiredAsterisk = () => {
    return <Text color={'primary.300'}>*</Text>;
  };

  const flag = () => {
    return (
      <Box p={4} borderRightWidth={1} borderColor={'surface.300'} fontSize={16}>
        <Text>{regionFlag('US')}</Text>
      </Box>
    );
  };

  return (
    <VStack space={1} flex={1}>
      <HStack space={0.5}>
        {title ? (
          <Text color={'white'} fontWeight={500} fontSize={15}>
            {title}
          </Text>
        ) : null}
        {isRequired ? requiredAsterisk : null}
      </HStack>
      <HStack bg={'transparent'}>
        <TextArea
          isDisabled={disabled}
          onFocus={() => {
            setFocused(true);
          }}
          onBlur={onBlur}
          onChangeText={(text) => {
            onChangeText(text);
          }}
          h={height}
          pb={3}
          flex={1}
          placeholder={placeholder ? placeholder : title ? title : type}
          placeholderTextColor={placeholderTextColor ?? 'surface.400'}
          autoCapitalize={autoCapitalize}
          color={focused ? 'white' : inactiveTextColor ?? null}
          autoCorrect={autoCorrect}
          fontSize={16}
          fontWeight={400}
          letterSpacing={'-0.3px'}
          alignSelf={'stretch'}
          secureTextEntry={type == InputType.Password}
          value={value}
          rounded={0}
          focusOutlineColor={'transparent'}
          borderTopColor={'transparent'}
          borderLeftColor={'transparent'}
          borderRightColor={'transparent'}
          borderBottomColor={focused ? 'primary.400' : 'surface.300'}
          borderWidth={2}
          // style={{ '&::WebkitScrollbar': { width: 0, height: 0 } }}
        ></TextArea>
      </HStack>
    </VStack>
  );
};
